import React, { useState, useEffect } from "react";
import Form from "react-bootstrap/Form";
import _ from "lodash";
import uuid from "react-uuid";
import Loading from "../../../common/components/loading/loading";
import { getVenues } from "../../../common/services/markets/venueService";
import SearchBox from "../../../common/components/search/searchBox";
import VenuesTable from "./venuesTable";
import { useTranslation } from "react-i18next";

const Venues = ({ onClick, allowEdit }) => {
  const { t } = useTranslation(["markets"]);
  const [venues, setVenues] = useState([]);
  const [searchQuery, setSearchQuery] = useState("");
  const [activeOnly, setActiveOnly] = useState(true);
  const [sortColumn, setSortColumn] = useState({ path: "name", order: "asc" });
  const [isLoading, setIsLoading] = useState(true);
  const [paginationState, setPaginationState] = useState({
    currentPage: 0,
    pageSize: 20,
  });

  useEffect(() => {
    (async () => {
      setVenues(await getVenues());
      setIsLoading(false);
    })();
  }, []);

  const handleVenueUpdated = (venue) => {
    setVenues((prevVenues) => {
      const updatedVenues = [...prevVenues];
      const index = updatedVenues.findIndex((u) => u.venueId === venue.venueId);
      if (index > -1) {
        updatedVenues.splice(index, 1);
      }
      updatedVenues.push(venue);
      return updatedVenues;
    });
  };

  const handleSearch = (query) => {
    setSearchQuery(query);
    setPaginationState((prev) => ({ ...prev, currentPage: 0 }));
  };

  const handleSort = (colId, sort) => {
    if (colId && sort) {
      setSortColumn({ path: colId, order: sort });
    }
  };

  const handleToggleActiveOnly = () => {
    setActiveOnly((prev) => !prev);
    setPaginationState((prev) => ({ ...prev, currentPage: 0 }));
  };

  const handleVenueSelected = (venue, isNew = false) => {
    onClick(venue, handleVenueUpdated, isNew);
  };

  const handlePaginationChanged = (params) => {
    if (params && params.api) {
      setPaginationState({
        currentPage: params.api.paginationGetCurrentPage(),
        pageSize: params.api.paginationGetPageSize(),
      });
    }
  };

  const getFilteredData = () => {
    let filtered = venues;
    if (activeOnly) filtered = filtered.filter((u) => u.active);
    if (searchQuery)
      filtered = filtered.filter(
        (u) =>
          u.name != null &&
          u.name.toLowerCase().includes(searchQuery.toLowerCase())
      );
    const sorted = _.orderBy(filtered, [sortColumn.path], [sortColumn.order]);
    return { totalCount: filtered.length, data: sorted };
  };

  if (isLoading) return <Loading />;

  const { totalCount, data: filteredVenues } = getFilteredData();
  const newVenue = {
    venueId: uuid(),
    name: t("NewVenue"),
  };

  return (
    <div className="container-fluid">
      <div className="row">
        <div className="col">
          <SearchBox value={searchQuery} onChange={handleSearch} />
        </div>
        <div className="col">
          <Form.Switch
            className="switch"
            type="switch"
            label={t("ActiveOnly")}
            checked={activeOnly}
            value={activeOnly}
            onChange={handleToggleActiveOnly}
          />
        </div>
        <div className="col">
          {allowEdit && (
            <button
              onClick={() => handleVenueSelected(newVenue, true)}
              className="btn btn-sm btn-primary float-sm-right"
            >
              {t("AddVenue")}
            </button>
          )}
        </div>
      </div>
      <p>{t("RetrievedVenue", { count: totalCount })}</p>
      <VenuesTable
        venues={filteredVenues}
        onSort={handleSort}
        onRowClick={handleVenueSelected}
        onPaginationChanged={handlePaginationChanged}
        paginationState={paginationState}
      />
    </div>
  );
};

export default Venues;
